<p-messages severity="warn" *ngIf="isRange && (workerCalendarEvent.list_dates== null || workerCalendarEvent.list_dates.length == 0)">
    <ng-template pTemplate>
        Atención! Estas creando un evento para el rango de fecha {{workerCalendarEvent.start | date:'dd/MM/yyyy'}} - {{workerCalendarEvent.end | date:'dd/MM/yyyy'}}.
        Los eventos se crearán para cada día dentro de este rango.
    </ng-template>
</p-messages>

<p-messages severity="warn" *ngIf="isRange && workerCalendarEvent.list_dates != null && workerCalendarEvent.list_dates.length > 0">
    <ng-template pTemplate>
        Atención! Estas creando un evento para varias fechas.
        Los eventos se crearán para cada uno de los días seleccionados.
    </ng-template>
</p-messages>

<form *ngIf="workerCalendarEventsFormGroup" [formGroup]="workerCalendarEventsFormGroup">
    <div class="grid"> 
        <div class="col-12 input-field">
            <label for="calendarEventTypeId">Tipo de evento</label>
            <p-dropdown (onChange)="onCalendarEventTypeChange($event)" formControlName="calendarEventTypeId" [options]="calendarEventTypes"
                optionLabel="name" optionValue="id" appendTo="body" [filter]="true" filterBy="name"
                placeholder="Selecciona un tipo" d-form-field-error></p-dropdown>            
        </div>
        <div class="col-6 input-field" *ngIf="calendarEventTypeSelected.allowTimeRange">
            <label for="start">Desde *</label>
            <p-calendar [firstDayOfWeek]="1" inputId="start" [timeOnly]="true" appendTo="body" formControlName="start"
                d-form-field-error />
        </div>
        <div class="col-6 input-field" *ngIf="calendarEventTypeSelected.allowTimeRange">
            <label for="end">Hasta *</label>
            <p-calendar [firstDayOfWeek]="1" inputId="end" formControlName="end" [timeOnly]="true" appendTo="body"
                d-form-field-error />
        </div>
        <div class="col-12 input-field">
            <label for="description">Descripción</label>
            <input pInputText name="description" id="description" formControlName="description" />
        </div>        
    </div>     
    <div class="grid mt-2" *ngIf="caseServices.length > 0">
        <div class="col-12">Se han encontrado <b>servicios</b> en las fechas seleccionadas.</div>
        <div class="col-12 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="keepCaseServices" [binary]="true" value="true" />Va a atender los servicios</label>
        </div>
    </div>
    
    <div class="grid mt-2" *ngIf="guardShiftFoundModal">
        <div class="col-12">Se han encontrado <b>guardias</b> en las fechas seleccionadas.</div>
        <div class="col-12 input-field">
            <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox formControlName="keepGuardShifts" [binary]="true" value="true" />Va a atender la guardia</label>
        </div>
    </div>
    <div class="mt-4 flex gap-2 justify-content-end">
        <div class="flex-grow-1"></div>
        <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
    
</form>